import RemoveNode from '../component/2D/RemoveNode';
; (function () {
    'use strict';

    var directive = function () {
        return {
            restrict: 'E',
            template: [
               '<img data-toggle="tooltip" data-placement="top" title="Delete node" alt="Delete node"',
                    ' ng-click="buttonClick()" src="assets/images/tools/removeNode.png" />'
            ].join(''),
            replace: true,
            scope: {},
            controller: controller
        }
    };

    var dependencies = ['$scope', 'engine2DSrvc'];

    var controller = function ($scope, engine2DSrvc) {

        $scope.buttonClick = function () {
            engine2DSrvc.get().findComponentByType(RemoveNode).enable();
        };

    };

    controller.$inject = dependencies;

    angular.module('valleyCraftApp').directive('deleteNodeButton', directive);

})();